import getIndianCurrencyFormat from "./getIndianCurrencyFormat";
export default function getMonthlyEMI(amount: number, interestRate: number, years: number) {
  const time = years * 12;
  const r = interestRate / 1200;
  /* [P x R x (1+R)^N]/[(1+R)^N-1] */
  const powerValue = Math.pow(1 + r, time);
  const emi = (amount * r * powerValue) / (powerValue - 1);
  return getIndianCurrencyFormat(emi);
}

/**
 * Calculates the total EMI savings between dealer and AD offers.
 * Returns a formatted string (e.g., '₹12,000') or '-' if not positive/invalid.
 */
export function getEmiSavings({
  onRoadPrice,
  ADPrice,
  downPayment,
  otherInterest,
  adInterest,
  loanTenure,
  getMonthlyEMI,
  convertAmountToNumber,
  getIndianCurrencyFormat,
}: {
  onRoadPrice: number;
  ADPrice: number;
  downPayment: number;
  otherInterest: number;
  adInterest: number;
  loanTenure: number;
  getMonthlyEMI: (amount: number, interest: number, tenure: number) => number;
  convertAmountToNumber: (val: any) => number;
  getIndianCurrencyFormat: (val: number) => string;
}): string {
  const isValidNumber = (value: any): value is number =>
    typeof value === "number" && !isNaN(value);

  const dealerMonthlyEMI = convertAmountToNumber(
    getMonthlyEMI(onRoadPrice - downPayment, otherInterest, loanTenure)
  );
  const adMonthlyEMI = convertAmountToNumber(
    getMonthlyEMI(ADPrice - downPayment, adInterest, loanTenure)
  );

  if (
    isValidNumber(dealerMonthlyEMI) &&
    isValidNumber(adMonthlyEMI) &&
    isValidNumber(loanTenure)
  ) {
    const totalSavings = (dealerMonthlyEMI - adMonthlyEMI) * loanTenure * 12;
    return totalSavings > 0 ? `₹${getIndianCurrencyFormat(totalSavings)}` : "-";
  }
  return "-";
}
